import { createSlice } from "@reduxjs/toolkit";
import { fetchVendor_profile_update_requestsItems } from "./Vendor_profile_update_requestsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendor_profile_update_requestsSlice = createSlice({
  name: "vendor_profile_update_requests",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVendor_profile_update_requestsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendor_profile_update_requestsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVendor_profile_update_requestsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendor_profile_update_requestsSlice.reducer;